import { ApiIndividualResponse, ApiPaginatedResponse } from './api';
import { IEmailNamePair } from './education-provider-infos';
import { IOrder, IOrderWithCourseItem } from './order';
import { IUser } from './user';

export type ApiIndividualPayment = ApiIndividualResponse<IPayment>;
export type ApiPaginatedPayments = ApiPaginatedResponse<IPayment>;
export type ApiPayPayments = ApiIndividualResponse<IPayPayments>;

export enum PaymentInclude {
  Course = 'course',
  Order = 'order',
  User = 'user',
}

export enum PaymentType {
  RepaymentToEP = 'REPAYMENT_TO_EP',
  FixPayInstalment = 'FIXPAY_INSTALMENT',
  Upfront = 'UPFRONT',
  LearningBudget = 'LEARNING_BUDGET',
  OriginationCommission = 'ORIGINATION_COMMISSION',
}

export enum PaymentStatus {
  Authorized = 'AUTHORIZED',
  Pending = 'PENDING',
  InCheckout = 'IN_CHECKOUT',
  Expired = 'EXPIRED',
  WaitingFunds = 'WAITING_FUNDS',
  Paid = 'PAID',
  Failed = 'FAILED',
}

export enum PaymentMethod {
  CreditCard = 'CREDIT_CARD',
  BankTransfer = 'BANK_TRANSFER',
}

export enum PaymentResource {
  LearningBudget = 'learning_budget',
  TaxBenefits = 'tax_benefits',
  StudentRepayment = 'student_repayment',
}

export interface IPayPayments {
  paymentCodeReference: string;
  redirectUrl: string;
}

export interface IPayment {
  _id: string;
  user: IUser | string;
  totalAmount: number;
  currency: string;
  agreementFeeAmount: number;
  status: PaymentStatus;
  externalPaymentId?: string;
  paymentMethod: PaymentMethod;
  automaticPayout: boolean;
  transferred: boolean;
  paymentType: PaymentType;
  paymentResource: PaymentResource;
  scheduledTo?: Date;
  payer?: string;
  order?: IOrder;
  createdAt: Date;
  updatedAt: Date;
}

export interface IPaymentWithUser extends Omit<IPayment, 'user'> {
  user: IUser;
}

export interface IPaymentWithOrder extends Omit<IPayment, 'order'> {
  order: IOrderWithCourseItem;
}

export enum PaymentProviderType {
  Stripe = 'STRIPE',
}

export interface ICheckoutPayload {
  courseId: string;
  cohortId: string;
  paymentOptions: {
    type: PaymentOption;
    amount: number;
    mode?: PaymentOptionMode;
    numberOfInstalments?: number;
    reviewerEmails?: IEmailNamePair[];
  }[];
}

export enum PaymentOption {
  Card = 'card',
  Klarna = 'klarna',
  FixPay = 'fix_pay',
  Isa = 'isa',
  LearningBudget = 'learning_budget',
  TaxBenefits = 'tax_benefits',
  Fundae = 'fundae',
  Free = 'free',
  NoAgreement = 'no_agreement',
}

export enum PaymentOptionMode {
  Upfront = 'upfront',
  Instalments = 'instalments',
}

export enum PaymentPayMethod {
  Card = 'card',
  BankTransfer = 'bank_transfer',
}
